module.exports = __webpack_public_path__ + "static/img/分类图片2@2x.d1cdbd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片2@2x.png
// module id = HujT
// module chunks = 192